export class Product {
  color_name: string;
  color_supplier_name: any;
  id: string;
  name: string;
  supplier_name: string;
  design_id: string;
  design_name: string;
  design_supplier_name: string;
  collection_id: string;
  collection_name: string;
  collection_supplier_name: string;
  fabric_type_id: string;
  fabric_type_name: string;
  supplier_id: string;
  piece_number: string;
  lot_number: string;
  length: string;
  weight_gsm: string;
  location_id: string;
  location_name: string;
  branch_id: string;
  branch_code: string;
  branch_name: string;
  deleted: string;
  last_updated: string;
  created_by: string;
  updated_by: string;

  unit_price_eur: string;

  customs_code: string;
  width: string;
  country_of_origin_name: string;
  country_of_origin_id: number;
  composition: string;
  notes: string;

  attachments: string[] = [];
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/products/product.ts